/**
 * Normaliza uma claim JWT para sempre retornar um array de strings.
 *
 * JWTs serializam arrays de um único elemento como string escalar (ex.: "6"),
 * e arrays com múltiplos elementos como array (ex.: ["6","1"]). Esse helper
 * garante que o consumidor sempre receba um array, independentemente do
 * formato emitido pelo Identity Server.
 */
export function toClaimArray(value: unknown): string[] {
  if (Array.isArray(value)) return value.map(String);
  if (value === null || value === undefined || value === '') return [];
  return [String(value)];
}
